import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';

import './AppHeaderAdmin.scss';

export const AppHeaderAdmin = ({ isProspectus }) => {
  const { t } = useTranslation();
  const { t: common } = useTranslation('common');

  const navigate = useNavigate();
  const location = useLocation();

  const menuRegistry = [
    {
      path: '/list',
      label: t('admin.list'),
    },
  ];

  const menuProspectus = [
    {
      path: '/groups',
      label: common('admin.groups'),
    },
    {
      path: '/list',
      label: t('admin.list'),
    },
  ];

  const chooseMenu = (isProspectus) => {
    return isProspectus ? menuProspectus : menuRegistry;
  };

  return (
    <div className="app-header-admin" data-testid="app-header-admin">
      <div className="container app-header-admin__content">
        {/* TODO change this to link if we have more operations */}
        <span className="app-header-admin__panel" data-testid="admin-panel">
          {common('admin.panel')}
        </span>
        <div className="app-header-admin__menu">
          {chooseMenu(isProspectus).map(({ path, label }) => {
            const isMenuItemActive = location.pathname === path;

            return (
              <div
                key={path}
                className={classnames('app-header-admin__list', {
                  'app-header-admin__list--active': isMenuItemActive,
                })}
                onClick={() => (isMenuItemActive ? null : navigate(path))}
                data-testid="admin-panel-list-item"
              >
                <span>{label}</span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
